import React from 'react';

import { Container } from './styles';

const FormLabel: React.FC = ({children}) => {
  return <Container>{children}</Container>;
}

export default FormLabel;